const METHOD = {
    bni: 1,
    bsim: 2
};

export default METHOD;
